<template>
  <div class="guide-component">
    <h4 class="guide-header">{{ tagFamily.name }}</h4>
    <div class="guide-content">
      <ImageCheckboxBlocks
        :content="tagFamily.availableValues"
        :checkedValues="checkedValues"
        :guideImageMap="GuideImageMap"
        @change="onChange"
      ></ImageCheckboxBlocks>
    </div>
    <div class="btns-container row">
      <div class="col">
        <div class="btn btn-outline-secondary col" @click="prev">
          Previous
        </div>
      </div>
      <div class="col">
        <div class="btn btn-secondary col" @click="setAndClose">
          Show results
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GuideImageMap from "@/models/GuideImageMap";

export default {
  name: "GuideComponent",
  props: ["tagFamily", "preFilters"],
  data() {
    return {
      checkedValues: [...this.tagFamily.setValues],
      GuideImageMap
    };
  },
  methods: {
    onChange(value) {
      const index = this.checkedValues.indexOf(value);
      if (index !== -1) {
        this.checkedValues.splice(index, 1);
      } else {
        this.checkedValues.push(value);
      }
    },
    prev() {
      this.$emit("prev");
    },
    isChecked(value) {
      return this.checkedValues.includes(value);
    },
    setAndClose() {
      this.$emit("setAndClose", {
        tagFamily: this.tagFamily.tag,
        checkedValues: this.checkedValues
      });
    }
  },
  created() {
    if (!this.preFilters) {
      this.checkedValues = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.link-btn {
  float: right;
  text-decoration: underline;
}
</style>
